import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { datadogRum } from '@datadog/browser-rum';
import App from '@/App';
import { StandaloneAppConfig } from '@/StandaloneAppConfig';

import '@antimatterhq/ui/css/base.css';
import '@antimatterhq/ui/css/variables.css';

async function initialize() {
  // Fetch this from environment config in case we want to dynamically enable profiling
  try {
    const response = await fetch('/environment');
    const data = (await response.json()) as StandaloneAppConfig;

    if (data.DATADOG_APPLICATION_ID && data.DATADOG_CLIENT_TOKEN) {
      // Don't initialize datadog rum for local development
      if (data.NODE_ENV === 'local') {
        return data;
      }

      datadogRum.init({
        applicationId: data.DATADOG_APPLICATION_ID,
        clientToken: data.DATADOG_CLIENT_TOKEN,
        version: import.meta.env.VITE_VERSION,
        site: 'datadoghq.com',
        service: 'antimatter-standalone',
        env: data.DATADOG_ENV,
        defaultPrivacyLevel: 'mask-user-input',
        traceSampleRate: 0,
        sessionSampleRate: 0,
        telemetrySampleRate: 0,
        sessionReplaySampleRate: 0,
        startSessionReplayRecordingManually: true,
        trackResources: false,
        trackUserInteractions: false,
      });
    }
    return data;
  } catch (error) {
    console.error(error);
    return undefined;
  }
}

async function render() {
  const config = await initialize();

  const root = createRoot(document.getElementById('root')!);

  root.render(
    <StrictMode>
      <App config={config} />
    </StrictMode>,
  );
}

render();
